export const LIST_NURSERY_DISCOUNTS = 'LIST_NURSERY_DISCOUNTS'
export const LIST_NURSERY_DISCOUNTS_SUCCESS = 'LIST_NURSERY_DISCOUNTS_SUCCESS'
export const LIST_NURSERY_DISCOUNTS_FAILED = 'LIST_NURSERY_DISCOUNTS_FAILED'
export const CLEAR_LIST_NURSERY_DISCOUNTS = 'CLEAR_LIST_NURSERY_DISCOUNTS'
